module.exports = __webpack_public_path__ + "first-50-watermark.jpg?eed856ca9dbc124f7c1a7b184a61bf91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50-watermark.jpg
// module id = 537
// module chunks = 0